import update from 'immutability-helper';
import { createReducer } from '../utils';
import {
  AUTH_LOGIN_USER_REQUEST,
  AUTH_LOGIN_USER_SUCCESS,
  AUTH_LOGIN_USER_FAILURE,
  AUTH_LOGIN_USER_MESSAGE,
  AUTH_LOGOUT_USER,
  AUTH_RECOVER_FAILURE,
  AUTH_RECOVER_REQUEST,
  AUTH_RECOVER_SUCCESS,
  AUTH_UPDATE_USER_SUCCESS,
} from '../constants';


const initialState = {
  token: null,
  profile: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  perms: [],
};

export default createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [AUTH_LOGIN_USER_REQUEST]: (state, payload) => Object.assign({}, state, {
    isAuthenticating: true,
    isAuthenticated: false,
    statusText: null,
  }),
  [AUTH_LOGIN_USER_SUCCESS]: (state, payload) => Object.assign({}, state, {
    isAuthenticating: false,
    isAuthenticated: true,
    token: payload.token,
    profile: payload.profile,
    perms: payload.perms,
    statusText: 'You have been successfully logged in.',
  }),
  [AUTH_LOGIN_USER_FAILURE]: (state, payload) => Object.assign({}, state, {
    isAuthenticating: false,
    isAuthenticated: false,
    token: null,
    perms: initialState.perms,
    statusText: `Authentication Error: ${payload.status} - ${payload.statusText}`,
  }),
  [AUTH_LOGIN_USER_MESSAGE]: (state, payload) => Object.assign({}, state, {
    isAuthenticating: false,
    isAuthenticated: false,
    token: null,
    perms: initialState.perms,
    statusText: `${payload}`,
  }),
  // eslint-disable-next-line no-unused-vars
  [AUTH_LOGOUT_USER]: (state, payload) => Object.assign({}, state, {
    isAuthenticated: false,
    isAuthenticating: false,
    token: null,
    profile: initialState.profile,
    perms: initialState.perms,
    statusText: 'You have been successfully logged out.',
  }),
  [AUTH_RECOVER_REQUEST]: (state, payload) => Object.assign({}, state, {
    statusText: 'Requesting email',
  }),
  [AUTH_RECOVER_SUCCESS]: (state, payload) => Object.assign({}, state, {
    statusText: 'Check your email to recover your log in.',
  }),
  [AUTH_RECOVER_FAILURE]: (state, payload) => Object.assign({}, state, {
    statusText: 'Error: Unable to request email. Try back later.',
  }),
  [AUTH_UPDATE_USER_SUCCESS]: (state, payload) => {
    return update(state,
      {
        profile: { $set: payload },
      });
  },

});



// WEBPACK FOOTER //
// src/reducers/auth.js